/*
 * Hover quick-add overlay (Huckberry-style).
 *
 * Each .js-quick-add-overlay block on the page is one product's overlay. Inside:
 *   - a Shopify product form (action=/cart/add) that's already wired into the
 *     theme's existing ajaxCart plugin via the .js-product-form class
 *   - a JSON variant map: [[variant_id, color_value, size_value, available], ...]
 *   - one button.quick-add-overlay__pill per size value (for products with sizes),
 *     OR a single submit button (for products without)
 *
 * Click flow:
 *   1. User clicks a size pill
 *   2. We resolve (currentColor × clickedSize) → variant_id via the variant map
 *   3. Update the form's hidden `id` input to that variant_id
 *   4. Submit the form — ajaxCart intercepts, posts to /cart/add, opens drawer
 *
 * Color sync:
 *   The collection card already has a color-swatch row that swaps the card image
 *   on click (ProductCardSwatches in theme.js). We hook the same click events to
 *   update each overlay's "current color" so the next size-pill click resolves
 *   to the right (color × size) variant.
 */
(function() {
  "use strict";

  function $$(sel, parent) {
    return Array.prototype.slice.call((parent || document).querySelectorAll(sel));
  }

  function readVariantMap(overlay) {
    var node = overlay.querySelector(".js-quick-add-variants");
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent);
      // Each row: [id, color, size, available]
      return data.map(function(row) {
        return { id: row[0], color: row[1] || "", size: row[2] || "", available: !!row[3] };
      });
    } catch (e) {
      console.warn("quick-add-overlay: bad variant map", e);
      return [];
    }
  }

  function refreshPillState(overlay) {
    var color = overlay.dataset.currentColor || "";
    var variants = readVariantMap(overlay);
    var pills = $$(".js-quick-add-pill", overlay);

    pills.forEach(function(pill) {
      var size = pill.dataset.size || "";
      // Find a variant matching (color, size). If multiple variants match
      // (shouldn't happen in a normal catalog), prefer an available one.
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.color === color && v.size === size) {
          if (!match || v.available) match = v;
        }
      }
      if (!match) {
        pill.disabled = true;
        pill.removeAttribute("data-variant-id");
        pill.title = "Unavailable";
        return;
      }
      if (!match.available) {
        pill.disabled = true;
        pill.dataset.variantId = String(match.id);
        pill.title = "Sold out";
      } else {
        pill.disabled = false;
        pill.dataset.variantId = String(match.id);
        pill.title = "";
      }
    });
  }

  function setCurrentColor(overlay, color) {
    overlay.dataset.currentColor = color || "";
    refreshPillState(overlay);
  }

  function handlePillClick(overlay, pill) {
    var variantId = pill.dataset.variantId;
    if (!variantId || pill.disabled) return;

    var form = overlay.querySelector(".js-product-form");
    if (!form) return;
    var idInput = form.querySelector(".js-quick-add-id");
    if (idInput) idInput.value = variantId;

    // Visual: loading state on the clicked pill
    var originalLabel = pill.textContent;
    pill.classList.remove("is-added", "is-error");
    pill.classList.add("is-loading");
    pill.textContent = "...";

    // The existing ajaxCart handler depends on a CSS animationend on the
    // submit button to advance the post-add chain (cart refresh + open
    // drawer). Our hidden submit has no such animation, so we hook the
    // events ourselves and drive the chain manually.
    var $ = window.jQuery;
    var done = function(success) {
      pill.classList.remove("is-loading");
      pill.textContent = originalLabel;
      if (success) {
        // Green pill + checkmark for ~1.4s, then revert
        pill.classList.add("is-added");
        setTimeout(function() {
          pill.classList.remove("is-added");
        }, 1400);
      } else {
        pill.classList.add("is-error");
        setTimeout(function() {
          pill.classList.remove("is-error");
        }, 1800);
      }
    };

    if ($) {
      // Listen for the next afterAddItem event ONCE. ajaxCart fires it after
      // the AJAX add completes (before its own animation chain).
      $("body").one("afterAddItem.ajaxCart", function() {
        // Mark as success in the UI
        done(true);
        // Trigger the post-animation hook manually so the existing handler
        // (line ~4451 of theme.js) runs and opens the cart drawer. Args:
        //   quickShopElement = null (we're not inside a <quick-shop>)
        //   addedFromCard = true (the form is inside .product-card)
        // After waiting briefly so the user sees the green flash first.
        setTimeout(function() {
          $("body").trigger("afterButtonAnimation.ajaxCart", [null, true]);
        }, 350);
      });
      // If something goes wrong (server error, validation, etc.), ajaxCart
      // fires its own error event. Catch it so the pill doesn't stay stuck.
      $("body").one("ajaxError.ajaxCart afterCartLoadFail.ajaxCart", function() {
        done(false);
      });
    } else {
      // jQuery somehow missing — best effort
      setTimeout(function() { done(true); }, 1200);
    }

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  // Wire pill clicks for every overlay on the page.
  function init() {
    var overlays = $$(".js-quick-add-overlay");
    overlays.forEach(function(overlay) {
      refreshPillState(overlay);
      $$(".js-quick-add-pill", overlay).forEach(function(pill) {
        pill.addEventListener("click", function(e) {
          // Prevent the card's link click swallow — overlay is inside an <a>.
          e.preventDefault();
          e.stopPropagation();
          handlePillClick(overlay, pill);
        });
      });
      // No-size variant: full-width "Add to cart" button. The form already has
      // the default variant's id pre-set, so we just trigger submission and
      // run the same post-add feedback chain as the pills.
      var addBtn = overlay.querySelector(".js-quick-add-submit");
      if (addBtn) {
        addBtn.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          var form = overlay.querySelector(".js-product-form");
          if (!form) return;
          var originalLabel = addBtn.textContent;
          addBtn.classList.remove("is-added", "is-error");
          addBtn.classList.add("is-loading");
          addBtn.textContent = "Adding…";

          var $ = window.jQuery;
          var done = function(success) {
            addBtn.classList.remove("is-loading");
            addBtn.textContent = success ? "Added ✓" : "Try again";
            addBtn.classList.add(success ? "is-added" : "is-error");
            setTimeout(function() {
              addBtn.classList.remove("is-added", "is-error");
              addBtn.textContent = originalLabel;
            }, success ? 1400 : 1800);
          };
          if ($) {
            $("body").one("afterAddItem.ajaxCart", function() {
              done(true);
              setTimeout(function() {
                $("body").trigger("afterButtonAnimation.ajaxCart", [null, true]);
              }, 350);
            });
            $("body").one("ajaxError.ajaxCart afterCartLoadFail.ajaxCart", function() {
              done(false);
            });
          } else {
            setTimeout(function() { done(true); }, 1200);
          }

          if (typeof form.requestSubmit === "function") form.requestSubmit();
          else form.submit();
        });
      }
    });

    // Color sync: when the user clicks a color swatch on the card, the
    // existing ProductCardSwatches handler swaps the image. We piggyback on
    // the same click — find which card the swatch belongs to, then update
    // that card's overlay current-color from the swatch's aria-label.
    document.addEventListener("click", function(e) {
      var swatchItem = e.target.closest(".js-product-swatch-item");
      if (!swatchItem) return;
      var card = swatchItem.closest(".js-product-card");
      if (!card) return;
      var overlay = card.querySelector(".js-quick-add-overlay");
      if (!overlay) return;
      // The variant-swatch inside has aria-label set to the color value.
      var swatch = swatchItem.querySelector("variant-swatch");
      var label = swatch && swatch.getAttribute("aria-label");
      if (label) setCurrentColor(overlay, label);
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
